var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook2 = function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.098 12.387c0-5.943-4.819-10.762-10.762-10.762-5.944 0-10.763 4.82-10.763 10.762 0 5.372 3.935 9.825 9.081 10.633V15.5H7.921v-3.113h2.733v-2.37c0-2.697 1.607-4.188 4.065-4.188 1.178 0 2.41.21 2.41.21v2.649H15.77c-1.336 0-1.754.83-1.754 1.681v2.018h2.985l-.477 3.112h-2.508v7.522c5.146-.808 9.081-5.26 9.081-10.634Z",
    clipRule: "evenodd"
  })));
};
export default SvgFacebook2;